import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row gy-3" }
const _hoisted_2 = {
  key: 0,
  class: "col-12"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "fw-normal" }
const _hoisted_7 = { class: "col-md-7" }
const _hoisted_8 = { class: "col-md-7" }
const _hoisted_9 = { class: "col-md-7" }
const _hoisted_10 = { class: "col-md-5 align-self-end text-center" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, null, -1)
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 1,
  class: "col-12"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "col-md-12 px-4 py-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-normal" }, "No encontramos tu información", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, " Lamentablemente la información no coincide con nuestros registros. Si considerás que esto es un error te pedimos que por favor adjuntes foto del frente y dorso de la cédula verde de tu vehículo para que sea validado. Este proceso de validación puede demorar hasta 48 hs hábiles ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 py-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-normal" }, "Validación exitosa"),
  /*#__PURE__*/_createElementVNode("p", null, "Recuerde competar todos los datos para terminar la solicitud")
], -1)
const _hoisted_22 = {
  key: 0,
  class: "col-12"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_24 = [
  _hoisted_23
]

import { reactive, ref, watch } from 'vue'
import TheAttachedImages from '@/components/TheAttachedImages.vue'
import FormVin from '@/components/form/FormVin.vue'
import { formulariosService } from '@/services/formularios.service'
import FormCarVersion from './FormCarVersion.vue'
import FormCheck from './FormCheck.vue'

export interface DocumentationData {
  vin: string
  modelo: string
  clasico: boolean
  imagenCedulaFrente: string
  imagenCedulaDorso: string
  isClient: null | boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VipUser',
  props: {
    modelValue: null,
    title: null,
    required: { type: Boolean },
    descripcion: null,
    documento: null,
    noSeparador: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: DocumentationData
  title?: string
  required?: boolean
  descripcion?: string
  documento: string
  noSeparador?: boolean
};



const validating = ref(false)
const FormPatentComponent = ref<any>(null)

const formulario = reactive<{ [key: string]: any }>({
  vin: '',
  modelo: '',
  clasico: false,
  imagenCedulaFrente: '',
  imagenCedulaDorso: '',
  isClient: null
})



watch(
  () => props.documento,
  () => {
    if (FormPatentComponent.value) {
      FormPatentComponent.value.resetField()
    }
    formulario.vin = ''
    formulario.modelo = ''
    formulario.clasico = false
    formulario.imagenCedulaFrente = ''
    formulario.imagenCedulaDorso = ''
    formulario.isClient = null
  }
)
watch(
  () => formulario.vin,
  () => {
    formulario.imagenCedulaFrente = ''
    formulario.imagenCedulaDorso = ''
    formulario.isClient = null
  }
)

watch(formulario, (value) => {
  emit('update:modelValue', value)
})

const validar = async () => {
  try {
    validating.value = true
    const result = await formulariosService.stellantisValidacion(
      formulario.vin,
      props.documento
    )
    formulario.isClient = result
    validating.value = false
  } catch (error) {
    formulario.isClient = null
    validating.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.noSeparador)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h4", _hoisted_6, _toDisplayString(props.title ? props.title : 'Validacion de cliente'), 1),
      _createElementVNode("p", null, _toDisplayString(props.descripcion
            ? props.descripcion
            : 'Para validar que sos cliente nuestro, te pedimos que ingreses el modelo y los últimos seis dígitos del chasis de tu vehículo. Lo podés encontrar en tu cédula verde.'), 1)
    ]),
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(FormCarVersion, {
        disabled: !__props.documento || validating.value,
        modelValue: formulario.modelo,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formulario.modelo) = $event)),
        required: Boolean(formulario.vin),
        ref_key: "FormPatentComponent",
        ref: FormPatentComponent
      }, null, 8, ["disabled", "modelValue", "required"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(FormVin, {
        disabled: !__props.documento || validating.value,
        modelValue: formulario.vin,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formulario.vin) = $event)),
        required: props.required,
        ref_key: "FormPatentComponent",
        ref: FormPatentComponent
      }, null, 8, ["disabled", "modelValue", "required"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(FormCheck, {
        label: "esAutoClasico",
        modelValue: formulario.clasico,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formulario.clasico) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("button", {
          onClick: validar,
          type: "button",
          class: "btn text-center mt-2 mx-auto",
          disabled: 
            String(formulario.vin).length < 5 || validating.value || !__props.documento
          
        }, " Validar ", 8, _hoisted_13)
      ])
    ]),
    (!__props.noSeparador)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
      : _createCommentVNode("", true),
    (formulario.isClient === false)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _hoisted_19,
            _createVNode(TheAttachedImages, {
              title: "Cedula del vehículo (frente)",
              modelValue: formulario.imagenCedulaFrente,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formulario.imagenCedulaFrente) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(TheAttachedImages, {
              title: "Cedula del vehículo (dorso)",
              modelValue: formulario.imagenCedulaDorso,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formulario.imagenCedulaDorso) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_20
        ], 64))
      : _createCommentVNode("", true),
    (formulario.isClient === true)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _hoisted_21,
          (!__props.noSeparador)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})